import React from 'react'
import { connectToggleRefinement } from 'react-instantsearch-dom'
import InputCheckbox from '@bit/atd.web.forms.input-checkbox'

type PropsType = {
  attribute: string
  canRefine: boolean
  count: {
    checked: number
    unchecked: number
  }
  createURL: () => void
  currentRefinement: boolean
  defaultRefinement: boolean
  indexContextValue?: undefined
  label?: undefined
  refine: (currentRefinement: boolean) => void
  value: boolean
}

const ToggleRefinement = (props: PropsType) => {
  const { currentRefinement, label, refine } = props

  return (
    <InputCheckbox
      name={label}
      label={label}
      labelPlacement="right"
      size="small"
      checked={currentRefinement}
      onChange={() => refine(!currentRefinement)}
    />
  )
}

const CustomToggleRefinement = connectToggleRefinement(ToggleRefinement)

export default CustomToggleRefinement
